
/**
 * STRICT: Explicit Utdanning.no detection service
 * Only triggers on explicit mentions of Utdanning.no
 */

/**
 * STRICT: Check if query explicitly mentions Utdanning.no
 */
export function isExplicitUtdanningQuery(query: string): boolean {
  const lowerQuery = query.toLowerCase();
  
  console.log(`[Utdanning-Explicit] 🔍 STRICT EXPLICIT CHECK: "${query}"`);
  
  const explicitIndicators = [
    'utdanning.no', 'utdanningno', 'utdanning no',
    'søk utdanning.no', 'søke utdanning.no', 'finn på utdanning.no',
    'søk i utdanning.no', 'søk på utdanning.no'
  ];
  
  const isExplicit = explicitIndicators.some(indicator => lowerQuery.includes(indicator));
  
  if (isExplicit) {
    console.log(`[Utdanning-Explicit] ✅ EXPLICIT UTDANNING.NO: Integration mentioned`);
  } else {
    console.log(`[Utdanning-Explicit] ❌ NO EXPLICIT MENTION: Requires "Utdanning.no" or similar`);
  }
  
  return isExplicit;
}

/**
 * STRICT: Enhanced education query detection - requires explicit Utdanning.no mention
 */
export function isStrictEducationQuery(query: string): boolean {
  const lowerQuery = query.toLowerCase();
  
  console.log(`[Utdanning-Explicit] 🔍 STRICT EDUCATION DETECTION: "${query}"`);
  
  // ABSOLUTE PRIORITY: If Arbeidsplassen is mentioned, NEVER route to education
  const arbeidsplassenIndicators = [
    'arbeidsplassen', 'arbeidsplassen.no', 'nav arbeidsplassen',
    'søk arbeidsplassen', 'jobb', 'stillinger', 'ledige stillinger'
  ];
  
  const hasArbeidsplassen = arbeidsplassenIndicators.some(term => lowerQuery.includes(term));
  
  if (hasArbeidsplassen) {
    console.log(`[Utdanning-Explicit] 🏢 ARBEIDSPLASSEN PRIORITY: Never route to education`);
    return false;
  }
  
  // ABSOLUTE PRIORITY: If Enhetsregisteret is mentioned, NEVER route to education
  const enhetsregisterIndicators = [
    'enhetsregisteret', 'enhetsregister', 'brønnøysundregisteret',
    'brønnøysund', 'brreg', 'søk enhetsregisteret'
  ];
  
  const hasEnhetsregister = enhetsregisterIndicators.some(term => lowerQuery.includes(term));
  
  if (hasEnhetsregister) {
    console.log(`[Utdanning-Explicit] 🏛️ ENHETSREGISTER PRIORITY: Never route to education`);
    return false;
  }
  
  // STRICT: Only route to education if Utdanning.no is explicitly mentioned
  const isExplicitUtdanningMention = isExplicitUtdanningQuery(query);
  
  if (isExplicitUtdanningMention) {
    console.log(`[Utdanning-Explicit] ✅ EXPLICIT UTDANNING.NO: Education search approved`);
    return true;
  }
  
  console.log(`[Utdanning-Explicit] ❌ NO EXPLICIT UTDANNING.NO: General education terms require explicit mention`);
  return false;
}
